import React, { PropsWithChildren } from 'react';
import styles from './dictionary-components.module.scss';

export default function AkRed({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkRed}>{children}</span>;
}
